import { useEffect, useState } from 'react';

// <img> that falls back to `fallback` (initial / icon) when there's no photo
// or it fails to load — never a broken-image icon.
export default function ProfilePhoto({ src, fallback, className = 'w-full h-full object-cover', alt = '' }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  if (!src || failed) return fallback;
  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} />;
}
